import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import RouterPaths from '../../constants/RouterPaths';
import logo from '../../assets/img/logo.png';
import logoMobile from '../../assets/img/icons/logo-mobile.svg';
import CommonButton from '../../common/components/CommonButton';
import { CommonButtonVariants } from '../../constants/CommonButtonVariants';
import authCar from '../../assets/img/tsv-auth-car.png';
import blackWhiteRedCars from '../../assets/img/black-white-red-cars-min.png';
import { useMediaQuery } from '../../common/hooks/useMediaQuery';

function ConfirmResetPasswordPage() {
  const navigate = useNavigate();

  const isMobile = useMediaQuery('(max-width: 768px)');
  const isDesktop = useMediaQuery('(min-width: 1040px)');

  const { OUTLINED_RED, PRIMARY_RED } = CommonButtonVariants;

  const handleSignUpClick = () => {
    navigate(RouterPaths.REGISTER);
  };

  const handleLoginClick = () => {
    navigate(RouterPaths.LOGIN);
  };

  const authLogo = isMobile ? logoMobile : logo;

  return (
    <div className="auth__page auth__page--start">
      <div className="auth__container">
        <div className="auth__credentials-section">
          <div className="auth__header auth__header--wide">
            <Link to={RouterPaths.HOMEPAGE} className="auth__logo-link">
              <img src={authLogo} alt="The Stock Vault" className="auth__logo" />
            </Link>
          </div>
          <div className="auth__reset-confirmation-wrapper">
            <h3 className="auth__heading">Your password has been changed</h3>
            <p className="auth__forgot-password-description">
              You can now sign in using your new password.
            </p>
            <CommonButton
              type="submit"
              label="Login"
              className="auth__homepage-button"
              variant={OUTLINED_RED}
              handleClick={handleLoginClick}
            />
            <img
              src={blackWhiteRedCars}
              alt="Black, white, red cars"
              className="auth__reset-car-image"
            />
          </div>
        </div>

        <div className={classNames('auth__banner-section', !isDesktop && 'd-none')}>
          <div className="auth__banner-content">
            <h2 className="auth__banner-header">Want to sell the stock too?</h2>
            <h5 className="auth__banner-description">
              If you’re a franchised dealer, you can sign up today to list your stock.
            </h5>
            <CommonButton
              type="button"
              label="Log In"
              className="auth__sign-up-button"
              size="large"
              variant={PRIMARY_RED}
              handleClick={handleSignUpClick}
            />
          </div>
          <div className="auth__banner-image">
            <img src={authCar} alt="The Stock Vault Car" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmResetPasswordPage;
